import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export type SiderState = Readonly<{
  siderCollapsed: boolean;
  openKeys: string[];
}>;

export const initialState: SiderState = {
  siderCollapsed: false,
  openKeys: [],
};

export const tabsSlice = createSlice({
  name: "sider",
  initialState,
  reducers: {
    setSiderCollapsed: (state, action: PayloadAction<boolean>) => {
      state.siderCollapsed = action.payload;
    },
    toggleSidebar: (state) => {
      state.siderCollapsed = !state.siderCollapsed;
    },
    setOpenKeys: (state, action: PayloadAction<string[]>) => {
      state.openKeys = action.payload;
    },
  },
});

export const { setOpenKeys, setSiderCollapsed, toggleSidebar } =
  tabsSlice.actions;

export const siderReducer = tabsSlice.reducer;
